import { useFischer } from '@/composables/fischerPlugin';
import { useCookies } from '@/composables/cookies';
import axios from 'axios';

export const useAssistedServiceLogin = () => {
  const fischer = useFischer();
  const { cookies } = useCookies();

  const postAdminTokenInSession = async (accessToken: string, idToken: string) => {
    if (IS_SHOWROOM) {
      fischer.user.setAccessToken(accessToken, '24h');
      cookies.set('IdToken', idToken, undefined, undefined, undefined, undefined, 'Strict');
      return {
        LoginSuccessPage: '/assisted-service/assisted-service-account-management',
      };
    }
    const { data } = await axios.post('/webapi/shop/userapi/AgentLogin', {
      agent: {
        AccessToken: accessToken,
        IdToken: idToken,
      },
    });
    return data;
  };

  return { postAdminTokenInSession };
};
